export const MODE_NEW = "MODE_NEW";
export const MODE_EDIT = "MODE_EDIT";
export const MODE_INIT = "MODE_INIT";
